import type { FC, SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {}

const DocumentPaper3Lines: FC<Props> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.5343 4.38462C18.2518 4.38462 19.6447 5.77751 19.6447 7.49499L19.6447 16.505C19.6447 18.2225 18.2518 19.6154 16.5343 19.6154L9.08168 19.6154C7.3642 19.6154 5.97128 18.2225 5.97128 16.505L5.97128 7.49499C5.97128 5.77751 7.3642 4.38462 9.08168 4.38462L16.5343 4.38462ZM21.0293 7.49499C21.0293 5.01281 19.0165 3 16.5343 3L9.08168 3C6.59943 3 4.58666 5.01281 4.58666 7.49499L4.58666 16.505C4.58666 18.9872 6.59943 21 9.08168 21L16.5343 21C19.0165 21 21.0293 18.9872 21.0293 16.505L21.0293 7.49499Z"
        fill={props.fill || "currentColor" || "#747981"}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.5562 8.13811C16.5562 7.75575 16.2462 7.4458 15.8639 7.4458L13.5323 7.4458C13.15 7.4458 12.84 7.75575 12.84 8.13811C12.84 8.52046 13.15 8.83042 13.5323 8.83042H15.8639C16.2462 8.83042 16.5562 8.52046 16.5562 8.13811ZM16.5566 11.8736C16.5566 11.4913 16.2467 11.1813 15.8643 11.1813L9.75343 11.1813C9.37109 11.1813 9.06112 11.4913 9.06112 11.8736C9.06112 12.2559 9.37109 12.5659 9.75343 12.5659L15.8643 12.5659C16.2467 12.5659 16.5566 12.2559 16.5566 11.8736ZM16.5566 15.6178C16.5566 15.2355 16.2467 14.9255 15.8643 14.9255L9.75343 14.9255C9.37109 14.9255 9.06112 15.2355 9.06112 15.6178C9.06112 16.0002 9.37109 16.3101 9.75343 16.3101H15.8643C16.2467 16.3101 16.5566 16.0002 16.5566 15.6178Z"
        fill={props.fill || "currentColor" || "#747981"}
      />
    </svg>
  );
};

export default DocumentPaper3Lines;
